import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import EditItem from './EditItem';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from './MessageInfoModal.module.scss';

const EditsTab = ({ selector }) => {
  const { t } = useTranslation();
  const messageHistories = useSelector(selector)?.messageLogs?.histories ?? [];

  return (
    <div className={scss.editsList}>
      {messageHistories.length ? (
        messageHistories.map(({ updatedOn, updatedBy, message }, index) => (
          <EditItem key={index} updatedOn={updatedOn} updatedBy={updatedBy} message={message} />
        ))
      ) : (
        <div className={scss.emptyLogs}>
          <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.emptyLogsIcon} />
          {t('noData')}
        </div>
      )}
    </div>
  );
};

export default memo(EditsTab);
